"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.appLink2Http = appLink2Http;
exports.cssPath = cssPath;
exports.defaults = defaults;
exports.findParentEl = findParentEl;
exports.findTrackName = findTrackName;
exports.getUserInfo = getUserInfo;
exports.http2AppLink = http2AppLink;
exports.isAppGoH5Link = isAppGoH5Link;
exports.isAppProtocol = isAppProtocol;
exports.isCustomizeSchema = isCustomizeSchema;
exports.isFn = isFn;
exports.isH5ProdEnv = isH5ProdEnv;
exports.isHttpProtocol = isHttpProtocol;
exports.isNil = isNil;
exports.isProdEnv = isProdEnv;
exports.isStr = isStr;
exports.merge = merge;

var _IGC_JS2Native = require("../IGC_JS2Native");

var _env = require("../env");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * 判断是否为 Nil（null/undefined）
 * @param {*} obj
 * @returns {boolean}
 */
function isNil(obj) {
  return obj == null;
}

function isFn(obj) {
  return typeof obj === 'function';
}

function isStr(obj) {
  return typeof obj === 'string';
}
/**
 * 设置默认属性
 * 目标对象中如果是 null 或 undefined，则会被默认配置覆盖。
 * 同时默认配置会过滤掉 null 和 undefined 的字段
 * @param {Object} obj 目标对象
 * @param {Object} defObj 默认配置
 * @returns {Object}
 */


function defaults(obj, defObj) {
  var mergeObj = _objectSpread({}, obj);

  for (var key in defObj) {
    if (defObj.hasOwnProperty(key)) {
      var value = defObj[key];

      if (!isNil(value) && isNil(mergeObj[key])) {
        mergeObj[key] = value;
      }
    }
  }

  return mergeObj;
}

function merge() {
  var result = {};

  while (arguments.length) {
    var defObj = Array.prototype.shift.call(arguments);

    for (var key in defObj) {
      if (defObj.hasOwnProperty(key)) {
        var value = defObj[key];

        if (!isNil(value)) {
          result[key] = value;
        }
      }
    }
  }

  return result;
}
/**
 * 显示元素的 CSS Path
 * @param {HTMLElement} el
 * @returns {string|undefined}
 */


function cssPath(el) {
  if (!(el instanceof Element)) {
    return;
  }

  var path = [];

  while (el.nodeType === Node.ELEMENT_NODE) {
    var selector = el.nodeName.toLowerCase();

    if (el.id) {
      selector += '#' + el.id;
    } else {
      var sib = el,
          nth = 1;

      while (sib.nodeType === Node.ELEMENT_NODE && (sib = sib.previousSibling)) {
        nth++;
      }

      selector += ':nth-child(' + nth + ')';
    }

    path.unshift(selector);
    el = el.parentNode;
  }

  return path.join(' > ');
}
/**
 * 查找指定元素，如无则一直向父级查找，直至根节点
 * @param {HTMLElement} el 起始元素
 * @param {Function} fn 查询函数，返回 true 则表示命中
 * @returns {HTMLElement|null}
 */


function findParentEl(el, fn) {
  var findEl;
  var curEl = el;

  while (curEl && curEl.tagName !== 'HTML' && curEl.nodeType === Node.ELEMENT_NODE) {
    if (fn(curEl)) {
      findEl = curEl;
      break;
    } else {
      curEl = curEl.parentNode;
    }
  }

  return findEl;
}
/**
 * 查找 trackName 事件名称
 * @param {Object} config 发送 LogTrack 时携带的 value
 * @returns {string|null}
 */


function findTrackName(config) {
  var trackName = undefined;

  if (config !== undefined) {
    if ('__ev_track_name' in config) {
      trackName = config.__ev_track_name;
    }
  }

  return trackName;
}
/**
 * 获取用户和设备的信息
 * @returns {Object} 用户的 did 和 pid 的对象
 */


function getUserInfo() {
  var d = {
    appChannel: '',
    appDeviceKey: '',
    appDeviceType: '',
    appToken: '',
    appUserPid: '',
    appUserAppAgent: '',
    appVersion: '',
    isLogin: false
  };
  var p = new Promise(function (resolve) {
    if (_env.env.isApp) {
      (0, _IGC_JS2Native.JS2Native)({
        name: 'getUserInfo'
      }).then(function (res) {
        if (res.code === 0) {
          if (Object.prototype.toString.call(res.data) === '[object Object]') {
            var json = res.data;
            var appChannel = json['App-Channel'];
            var appDeviceKey = json['App-Device-Key'];
            var appDeviceType = json['App-Device-Type'];
            var appToken = json['App-Token'];
            var appUserPid = json['App-User-Pid'];
            var appUserAppAgent = json['App-UserApp-Agent'];
            var appVersion = json['App-Version'];
            var isLogin = json['isLogin'];
            resolve({
              appChannel: appChannel,
              appDeviceKey: appDeviceKey,
              appDeviceType: appDeviceType,
              appToken: appToken,
              appUserPid: appUserPid,
              appUserAppAgent: appUserAppAgent,
              appVersion: appVersion,
              isLogin: isLogin
            });
          } else {
            resolve(d);
          }
        } else {
          resolve(d);
        }
      });
    } else {
      var userInfo = JSON.parse(localStorage.getItem('IGetCool-USER-Info')) || {};
      d.appUserPid = userInfo.uid ? userInfo.uid : '';
      resolve(d);
    }
  });
  return p;
}
/**
 * 根据域名区分H5生产还是正式环境，简单版，精确版使用下面的 isProdEnv
 */


function isH5ProdEnv() {
  // 简单粗暴的判断了域名
  return location.hostname === 'igetcool-share.igetcool.com';
}
/**
 * 根据域名区分生产还是正式环境
 */


function isProdEnv() {
  var hostname = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : location.hostname;
  var regExp = /^(.*)\.igetcool\.com$/i;
  var matches = hostname.match(regExp);

  if (matches) {
    var subHost = matches[1] || '';
    var devRegExp = /(sim|test|dev|local)/i;
    return !devRegExp.test(subHost);
  }

  return false;
}

function isHttpProtocol(url) {
  var httpReg = /^(http|https):\/\//ig;
  return httpReg.test(url);
}

function isAppProtocol(url) {
  var reg = /^igetcool:\/\//ig;
  return reg.test(url);
}

function isCustomizeSchema(url) {
  var reg = /^[\w\.]+:\/\//i;
  return reg.test(url);
}

function http2AppLink(url) {
  if (isHttpProtocol(url)) {
    return "igetcool://juvenile.dedao.app/go/h5?params_url=".concat(encodeURIComponent(url));
  }

  return url;
}
/**
 * 从 go/h5 中解析跳转地址，如果解析不出地址，返回原地址
 * @param {string} url
 * @returns {string}
 */


function appLink2Http(url) {
  if (isAppProtocol(url)) {
    var reg = /^igetcool:\/\/juvenile\.dedao\.app\/go\/h5(.*)$/i;
    var matches = url.match(reg);

    if (matches && matches[1]) {
      var urlSearch = new URLSearchParams(matches[1]);
      var paramsUrl = urlSearch.get('params_url');

      if (paramsUrl) {
        return paramsUrl;
      }
    }
  }

  return url;
}
/**
 * 判断是否为 go/h5 的链接
 * @param {string} url
 * @returns {boolean}
 */


function isAppGoH5Link(url) {
  var reg = /^igetcool:\/\/juvenile\.dedao\.app\/go\/h5(.*)$/i;
  var matches = url.match(reg);
  return !!matches;
}